

import { defineComponent, computed, onMounted, ref, reactive } from 'vue';
import { Container } from 'inversify';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';
import CustomSteps from '../../../../../common/infrastructure/componentes/base/common/controles/CustomSteps.vue';
import { IapComponentDataSource } from '../../../component/domain/iapComponentDataSource';
import * as XLSX from 'xlsx';
import MessageService, { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import OperationDataTypeConst from '../../../../../common/domain/constantes/OperationDataTypeConst';
import { dataUpdate } from '../../../dataupdate/domain/dataUpdate';
import HelperOperationData from '../../../../../common/infrastructure/funciones/HelperOperationData';
import DataSourceUtilComp from "../../../crud/infrastructure/functions/dataSourceUtilComp";
import SqlTypesConst from '@ilinium/shared/src/common/domain/constantes/SqlTypesConst';
import DataSourceConst from '../../../crud/infrastructure/functions/dataSourceConst';
import TypeScriptTypesConst from '../../../../../common/domain/constantes/TypeScriptTypesConst';
import { validate as isValidUUID } from 'uuid';
import { TYPES } from '@ilinium/shared/src/common/domain/types';
import HelperLoading from '@ilinium/shared/src/common/infrastructure/funciones/HelperLoading';
import CatalogDbType from '../../../catalog/domain/const/CatalogDbType';
import { IServiceSearch } from '../../../search/application/IServiceSearch';
import { clave } from '../../../dataupdate/domain/clave';
import HelperUtils from '../../../../../common/infrastructure/funciones/HelperUtils';
import { useStore } from 'vuex';	
interface myColumnsObject {
    id: string;
    value: string;
}

export default defineComponent({
    name: 'importdatathrowdatasource',
    props: {
        container: {
            type: Object as () => Container
        },
        dialogVisible: Boolean,

        compDataSource: {
            type: Object as () => IapComponentDataSource,
            default: () => ({})
        }
    },
    components: {
        CustomSteps,
    },
    setup(props, { emit }) {        
        const store = useStore();
        const selectedTab = ref(0);
        const compDataSource = props.compDataSource;
        const selectedItems = ref([]);
        let options: any = [];
        options.push({ id: 'unselected', desc: 'No sincronizar' });
        const _options = compDataSource.iapComponentDataSourceFieldConfigurations.filter(cdsfc => cdsfc.import == true).map(c => ({ id: c.dataSourceField?.id, desc: c.dataSourceField?.field }));
        options = options.concat(_options);
        let myFile = ref([]);

        const filters = ref({
            'global': { value: '', matchMode: FilterMatchMode.CONTAINS },
            'date': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });

        const nextPage = () => {
            let canDo = true;
            let validate: boolean[] = [];
            let messages = '';
            let selectedItemsTranslated: any[] = JSON.parse(JSON.stringify(selectedItems.value));

            if (compDataSource.dataSource.iapDataSourceFields.filter(cds => cds.primaryKey == true && !myFile.value.find(f => f[1] == cds.id)).length > 0) {
                canDo = false;
                messages += '\n El campo ' + compDataSource.dataSource.iapDataSourceFields.find(cds => cds.primaryKey == true && myFile.value.filter(f => f[0] == cds.field && f[1] != ''))?.field + ' es clave primaria y debe sincronizarse.'
            }
            else {
                for (let i = 0; i < selectedItems.value.length; i++) {
                    for (let j = 0; j < myFile.value.length; j++) {
                        var fieldConf = compDataSource.iapComponentDataSourceFieldConfigurations.find(cdsfc => cdsfc.dataSourceFieldId == myFile.value[j][1]);
                        if (fieldConf && fieldConf.mandatory && fieldConf.dataSourceField && !selectedItems.value[i][myFile.value[j][0]]) {
                            canDo = false;
                            messages += '\n El campo ' + fieldConf.dataSourceField.field + ' es obligatorio y no puede estar vacío.'
                        }

                        var field = compDataSource.dataSource.iapDataSourceFields.find(dsfc => dsfc.id == myFile.value[j][1]);

                        if (field) {
                            var obj = selectedItemsTranslated[i];
                            //var _delete = false;
                            //if (obj[field.field] == undefined) {// Si ya existe un campo con ese nombre no podemos luego borrarlo pq se está sobreescribiendo en el mismo campo y no añadiendo uno
                            //    _delete = true;
                            //}
                            obj[compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + field.tableName + DataSourceConst.DELIMITERFIELDS + field.field] = obj[myFile.value[j][0]];
                            obj['dataBase'] = compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos;
                            obj['table'] = field.tableName;

                            //if (_delete) {
                            delete (obj[myFile.value[j][0]]);
                            //}
                            //selectedItemsTranslated.push(obj);
                        }

                        if (field && field.primaryKey && !selectedItems.value[i][myFile.value[j][0]]) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es clave primaria y no puede estar vacío.'
                        }

                        if (field && (field.sqlType == SqlTypesConst.VARCHAR || field.sqlType == SqlTypesConst.NVARCHAR || field.sqlType == SqlTypesConst.VARBINARY ||
                            field.sqlType == SqlTypesConst.TEXT) && typeof selectedItems.value[i][myFile.value[j][0]] !== TypeScriptTypesConst.STRING) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo string y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        if (field && field.sqlType == SqlTypesConst.INT && !Number.isInteger(+selectedItems.value[i][myFile.value[j][0]]) && !(+selectedItems.value[i][myFile.value[j][0]] % 1)) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo entero y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        if (field && (field.sqlType == SqlTypesConst.DATE || field.sqlType == SqlTypesConst.DATETIME) && isNaN(selectedItems.value[i][myFile.value[j][0]]) && !isNaN(Date.parse(selectedItems.value[i][myFile.value[j][0]]))) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo fecha y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        if (field && field.sqlType == SqlTypesConst.BIT && !isBoolean(('' + selectedItems.value[i][myFile.value[j][0]]).toLowerCase())) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo booleano y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        if (field && field.sqlType == SqlTypesConst.UNIQUEIDENTIFIER && !isValidUUID(('' + selectedItems.value[i][myFile.value[j][0]]))) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo GUID y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        if (field && field.sqlType == SqlTypesConst.DECIMAL && !Number.isInteger(+selectedItems.value[i][myFile.value[j][0]]) && (+selectedItems.value[i][myFile.value[j][0]] % 1)) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo decimal y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        if (field && field.sqlType == SqlTypesConst.MONEY && !Number.isInteger(+selectedItems.value[i][myFile.value[j][0]])) {
                            canDo = false;
                            messages += '\n El campo ' + field.field + ' es de tipo moneda y el dato ' + selectedItems.value[i][myFile.value[j][0]] + ' no es válido.'
                        }

                        // Todo: insertar o update
                        // Todo: borrado de cosas
                    }
                }
            }

            if (selectedItemsTranslated.length == 0) {
                canDo = false;
                messages += '\n No se han seleccionado datos para sincronizar.'
            }
            if (canDo) {
                selectedTab.value++;
                if (isLastTab) {
                    loadPreviewData(selectedItemsTranslated);
                }
            }
            else {
                MessageService.showMessage(MessageType.Error, 'Error de validación', messages);
            }

        };

        const loadPreviewData = (selectedItemsTranslated: any[]) => {
            if (props.container) {
                const _srv = props.container.get<IServiceSearch>(
                    TYPES.SEARCH_REPOSITORY
                );
                HelperLoading.showLoading();

                const primaryKeyFields = compDataSource.dataSource.iapDataSourceFields.filter(dsf => dsf.primaryKey).map(f => f.field);
                let select = ' ';
                let i = 0;
                primaryKeyFields.forEach(field => {
                    select += i == 0 ? ' ' : ' ,';
                    select += field
                    i++;
                });
                let from = ' ' + compDataSource.dataSource.iapDataSourceFields[0].tableName;
                let where = ' ';
                i = 0;
                selectedItems.value.forEach(row => {
                    let j = 0;
                    where += i == 0 ? '' : ' OR ';
                    primaryKeyFields.forEach(keyField => {
                        const _field = myFile.value.filter(f => f[1] == compDataSource.iapComponentDataSourceFieldConfigurations.filter(dsfc => dsfc.dataSourceField?.field == keyField)[0].dataSourceFieldId)[0][0];
                        where += j == 0 ? ' (' : ' and';
                        where += keyField + ' = \'' + row[_field] + '\'';
                        j++;
                    });
                    where += ")";
                    i++;
                });

                _srv.getPreviewData(props.compDataSource.applicationId, props.compDataSource.applicationVersion,
                    props.compDataSource.dataSource.iapDataSourceDataBase?.idDataBaseType ?? CatalogDbType.SQLSERVER, props.compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos ?? '',
                    select, from, where, '', '', '', -1)
                    .then((response) => {
                        const results = JSON.parse(response?.items ?? '[]')?.items;
                        const { getPrimaryKeys, getValuesWithoutPrimaryKeys } = DataSourceUtilComp(props.compDataSource,store)
                        let myData: dataUpdate[] = [];
                        let canDo = true;
                        let notSincFieldsForInserts: any[] = [];
                        notSincFieldsForInserts = compDataSource.dataSource.iapDataSourceFields.filter(dsf => !selectedItemsTranslated.find(t => t[compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + compDataSource.dataSource.iapDataSourceFields[0].tableName + DataSourceConst.DELIMITERFIELDS + dsf.field]));
                        for (let i = 0; i < notSincFieldsForInserts.length; i++) {
                            for (let j = 0; j < selectedItemsTranslated.length; j++) {
                                if (getTipoOperacion(results, getPrimaryKeys(props.compDataSource.dataSource, selectedItemsTranslated[j], selectedItemsTranslated[j].table as any), selectedItemsTranslated[j]) == OperationDataTypeConst.INSERT) {
                                    var objDefaultValue = selectedItemsTranslated[j];
                                    var fieldConfig = compDataSource.iapComponentDataSourceFieldConfigurations.find(cdsfc => cdsfc.dataSourceFieldId == notSincFieldsForInserts[i].id);
                                    if (notSincFieldsForInserts[i].defaultValue) {
                                        objDefaultValue[compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + notSincFieldsForInserts[i].tableName + DataSourceConst.DELIMITERFIELDS + notSincFieldsForInserts[i].field] = undefined;
                                    }
                                    else if (fieldConfig && fieldConfig.mandatory) {
                                        canDo = false;
                                        MessageService.showMessage(MessageType.Error, 'Error de validación', 'El campo ' + notSincFieldsForInserts[i].field + ' es obligatorio y no puede estar vacío (INSERT).');
                                    }
                                    else {
                                        objDefaultValue[compDataSource.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + notSincFieldsForInserts[i].tableName + DataSourceConst.DELIMITERFIELDS + notSincFieldsForInserts[i].field] = undefined;//notSincFieldsForInserts[i].defaultValue;
                                    }
                                }
                            }
                        }

                        if (canDo) {
                            myData = selectedItemsTranslated.map(item => ({
                                valores: getValuesWithoutPrimaryKeys(props.compDataSource.dataSource, item, item.table as any, getTipoOperacion(results, getPrimaryKeys(props.compDataSource.dataSource, item, item.table as any), item)),
                                claves: getTipoOperacion(results, getPrimaryKeys(props.compDataSource.dataSource, item, item.table as any), item) == OperationDataTypeConst.INSERT ? [] : getPrimaryKeys(props.compDataSource.dataSource, item, item.table as any),
                                tipoOperacion: getTipoOperacion(results, getPrimaryKeys(props.compDataSource.dataSource, item, item.table as any), item),
                                id:HelperUtils.newGuid()
                            } as dataUpdate)) as dataUpdate[];

                            HelperOperationData.doOperationData(props.container, props.compDataSource, JSON.parse(JSON.stringify(myData)), true)
                            .then(response => {
                                if (response == true) {
                                    MessageService.showMessage(MessageType.Correcto, '', 'Datos importados correctamente', true, false, false, '', hideImportDialog());
                                }
                                else {
                                    MessageService.showToast(MessageType.Error, 'Error al importar', 'No se han podido importar los datos.');
                                }
                            })
                        }
                    })
                    .catch((err) => {

                    })
                    .finally(() => {
                        HelperLoading.hideLoading();
                    });
            }
        }

        const isLastTab = computed(() => {
            if (selectedTab.value === (itemsMenu.value.length - 1)) {
                return true;
            }

            return false;
        })

        const isDialogVisible = computed({
            get: () => props.dialogVisible,
            set: (val) => emit('update:dialogVisible', val),
        });

        const hideImportDialog = () => {
            isDialogVisible.value = false;
            eraseData();
        }

        const eraseData = () => {
            selectedTab.value = 0;
            selectedItems.value = [];
            myFile.value = [];
        }

        const itemsMenu = computed(() => {
            const response = [
                {
                    key: 'uploadFile',
                    id: 0,
                    label: 'Adjuntar fichero',
                    visible: true,
                },
                {
                    key: 'fileDataTable',
                    id: 1,
                    label: 'Datos del fichero',
                    visible: true
                },

                {
                    key: 'syncData',
                    id: 2,
                    label: 'Sincronizar datos',
                    visible: true,
                },

            ];

            return response.filter(x => x.visible);
        });

        const uploadFiles = ref();

        const getTipoOperacion = (results: any, primaryKeys: any, item: any) => {
            let filtered = JSON.parse(JSON.stringify(results));
            primaryKeys.forEach((element: any) => {
                filtered = filtered.filter((r: any) => r[element.field.substring(fullIdToId(element.field, DataSourceConst.DELIMITERFIELDS, 2))] == item[element.field])
            });

            return filtered.length > 0 ? OperationDataTypeConst.UPDATE : OperationDataTypeConst.INSERT
        }

        function fullIdToId(_string: string, subString: string, index: number) {
            return _string.split(subString, index).join(subString).length + 1;
        }

        const onSelectedFiles = (event: any) => {
            if (event.files[0].type == "text/csv") {
                HelperCommon.toText(event.files[0]).then((value) => {
                    const fileText = value as any;
                    const content = fileText.substr(fileText.indexOf(',') + 1);
                    let separator = csvDelimiter(fileText);
                    uploadFiles.value = csvJSON(fileText, separator);
                    myFile.value = arrToObj(Object.keys(uploadFiles.value[0]));
                    selectedTab.value = 1;
                });
            }
            else {
                HelperCommon.toArrayBuffer(event.files[0]).then((value) => {

                    uploadFiles.value = excelJSON(value);
                    myFile.value = arrToObj(Object.keys(uploadFiles.value[0]));
                    selectedTab.value = 1;
                });
            }
        };

        const csvJSON = (csv: any, separator = ',') => {
            var lines = csv.split("\n");
            var result: any = [];

            var headers = lines[0].split(separator);

            for (var i = 1; i < lines.length; i++) {

                var obj: any = {};
                var currentline = lines[i].split(separator);

                for (var j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j];
                }

                result.push(obj);
            }

            return result;
        }

        function isBoolean(text: string) {
            text = text.replace('\r', '').replace('\r', '');
            return (text === 'true' || text === '1' || text === 'false' || text === '0');
        }
        function arrToObj(arr: string[]) { //converting function
            let obj: any = {}
            for (let i = 0; i < arr.length; i++) {
                obj[arr[i]] = ''
            }

            var result: any = [];

            for (var i in obj)
                result.push([i, obj[i]]);

            return result;
        }

        const excelJSON = (e: any) => {
            var data = new Uint8Array(<ArrayBuffer>e);
            var workbook = XLSX.read(data, { type: 'array' });
            let sheetname = workbook.SheetNames[0]
            /* do something with workbook here */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetname];
            console.log(XLSX.utils.sheet_to_json(worksheet));
            return XLSX.utils.sheet_to_json(worksheet);
        }

        const csvDelimiter = (t: any) => {
            t = t.split("\n")[0];
            let delArray = [',', ';', '|', '    '];
            let comma = 0;
            let samiclon = 0;
            let pipe = 0;
            let tab = 0;
            delArray.forEach((e, i) => {
                if (i === 0) {
                    comma = t.split(e).length;
                } else if (i === 1) {
                    samiclon = t.split(e).length;
                } else if (i === 2) {
                    pipe = t.split(e).length;
                } else if (i === 3) {
                    tab = t.split(e).length;
                }
            });
            let tmpArray1 = [comma, samiclon, pipe, tab]
            let tmpArray = [comma, samiclon, pipe, tab];
            let maxLen = tmpArray.sort((a, b) => b - a)[0];
            let delimiter_i = 0;
            tmpArray1.forEach((e, i) => {
                if (maxLen === e) {
                    delimiter_i = i;
                }
            });
            if (delimiter_i === 0) {
                return ',';
            } else if (delimiter_i === 1) {
                return ';'
            } else if (delimiter_i === 2) {
                return '|'
            } else if (delimiter_i === 3) {
                return '    '
            }
        }

        return {
            selectedTab,
            nextPage,
            isLastTab,
            itemsMenu,
            onSelectedFiles,
            uploadFiles,
            isDialogVisible,
            compDataSource,
            arrToObj,
            myFile,
            options,
            filters,
            selectedItems
        };
    },
});
